export enum OrderViewTypeEnum {
  day,
  week,
  month,
}
